import React, { useState } from "react";
import {
    Box,
    Stepper,
    Step,
    StepLabel,
    Button,
    Typography,
    Card,
    CardContent,
    CardActionArea,
    Grid,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from "@mui/material";
import {
    CheckCircle,
    Done
} from "@mui/icons-material";
import { AddCompnayForm } from "./AddCompnay";
import { planCards, storeCards } from "../helperFunc/planList";

const steps = ['Select Store Type', 'Select Plan Type', 'Store Information'];

export default function MultiStepForm({ setshowModaladd }) {
    const [activeStep, setActiveStep] = useState(0);
    const [selectedCard, setSelectedCard] = useState(null); 
    const [formData, setFormData] = useState({
        storeType: '',
        planType: '',
    });


    const handleNext = () => {
        if (activeStep === 0 && selectedCard !== null) {
            setFormData(prev => ({ ...prev, storeType: storeCards[selectedCard].id }));
        }
        if (activeStep === 1 && selectedCard !== null) {
            setFormData(prev => ({ ...prev, planType: planCards[selectedCard].id }));
        }
        setSelectedCard(null); 
        setActiveStep(prev => prev + 1);
    };

    const handleBack = () => {
        setActiveStep(prev => prev - 1);
        setSelectedCard(null);
    };

    const isSelected = (index) => selectedCard === index;

    return (
        <Box sx={{ width: '100%', py: 1 }}>
            <Stepper activeStep={activeStep} alternativeLabel >
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <Box sx={{ mt: 4, px: 2 }}>
                {activeStep === 0 && (
                    <Box sx={{ overflowY: 'auto', maxHeight: '400px' }}>
                        <Typography variant="h6" textAlign="center" gutterBottom fontWeight="bold">
                            What kind of store are you running?
                        </Typography>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            {storeCards.map((card, index) => (
                                <Grid item xs={12} sm={6} key={index} >
                                    <Card sx={{
                                        border: isSelected(index) ? 2 : 1,
                                        borderColor: isSelected(index) ? 'primary.main' : 'grey.300',
                                        boxShadow: isSelected(index) ? 6 : 1,
                                        transition: 'all 0.2s ease-in-out',
                                        position: 'relative'
                                    }}>
                                        {isSelected(index) && (
                                            <CheckCircle color="primary" sx={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }} />
                                        )}
                                        <CardActionArea onClick={() => setSelectedCard(index)} sx={{ p: 1 }}>
                                            <Box sx={{ display: 'flex', p: 1, alignItems: 'center' }}>
                                                <Box sx={{ mr: 3, display: 'flex', justifyContent: 'center' }}>
                                                    {card.icon}
                                                </Box>
                                                <CardContent sx={{ p: 0 }}>
                                                    <Typography variant="h6" component="div" fontWeight="bold">
                                                        {card.title}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {card.description}
                                                    </Typography>
                                                </CardContent>
                                            </Box>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                )}

                {activeStep === 1 && (
                    <Box sx={{ overflowY: 'auto', maxHeight: '400px' }}>
                        <Typography variant="h6" textAlign="center" gutterBottom fontWeight="bold">
                            Choose a plan that fits your growth
                        </Typography>
                        <Grid container spacing={3} sx={{ mt: 1, justifyContent: 'center'}}>
                            {planCards.map((card, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Card sx={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        border: isSelected(index) ? 2 : 1,
                                        borderColor: isSelected(index) ? 'primary.main' : 'grey.300',
                                        boxShadow: isSelected(index) ? 6 : 1,
                                        transition: 'all 0.2s'
                                    }}>
                                        <CardActionArea onClick={() => setSelectedCard(index)} sx={{ flexGrow: 1, p: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                                            <CardContent sx={{ textAlign: 'center', padding:1 }}>
                                                <Typography variant="h5" fontWeight="bold" gutterBottom>
                                                    {card.title}
                                                </Typography>
                                                {/* <Box sx={{ my: 1 }}>
                                                    <Typography variant="h4" component="span" fontWeight="bold" color="primary">
                                                        {card.price}
                                                    </Typography>
                                                    <Typography variant="subtitle1" component="span" color="text.secondary">
                                                        {card.period}
                                                    </Typography>
                                                </Box> */}
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                                    {card.description}
                                                </Typography>
                                                <Divider sx={{ mb: 1 }} />
                                                
                                                <List dense disablePadding sx={{ textAlign: 'left' }}>
                                                    {card.features.map((feature, idx) => (
                                                        <ListItem key={idx} disableGutters sx={{ py: 0.25 }}>
                                                            <ListItemIcon sx={{ minWidth: 30 }}>
                                                                <Done sx={{ fontSize: 18, color: 'success.main' }} />
                                                            </ListItemIcon>
                                                            <ListItemText 
                                                                primary={feature} 
                                                                primaryTypographyProps={{ variant: 'body2', sx: { fontSize: '0.8rem' } }} 
                                                            />
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                )}

                {activeStep === 2 && (
                    <Box sx={{ maxWidth: 800, mx: 'auto' , overflowY: 'auto', maxHeight: '400px' }}>
                         <Typography variant="h6" textAlign="center" gutterBottom fontWeight="bold" sx={{ mb: 3 }}>
                            Enter your Store Information
                        </Typography>
                        <AddCompnayForm 
                            setmodel={setshowModaladd} 
                            storeType={formData.storeType} 
                            planType={formData.planType} 
                        />
                    </Box>
                )}
            </Box>

            {/* Navigation Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, px: 2 }}>
                <Button 
                    disabled={activeStep === 0} 
                    onClick={handleBack}
                    variant="text"
                >
                    Back
                </Button>

                {activeStep < steps.length - 1 ? (
                    <Button
                        variant="contained"
                        onClick={handleNext}
                        disabled={selectedCard === null}
                        size="large"
                        sx={{ px: 4 }}
                    >
                        Next
                    </Button>
                ) : null}
            </Box>
        </Box>
    );
}